// extracted by mini-css-extract-plugin
export var gatsbyImageWrapper = "styles-module--gatsby-image-wrapper--2u_kD";
export var gatsbyImageWrapperConstrained = "styles-module--gatsby-image-wrapper-constrained--1TFmx";